import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { Building2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@smithinternational.com");
  const [password, setPassword] = useState("Smith@2026");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) {
    nav("/", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block login-bg relative">
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="text-xs tracking-[0.3em] uppercase opacity-80">Trading ERP</div>
          <h1 className="font-display text-5xl font-black mt-3 leading-tight">
            The Smith
            <br /> International
          </h1>
          <p className="mt-4 max-w-md text-white/80">
            Manage suppliers & customers, price lists, purchase orders, invoices and your books — in one place.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16 bg-slate-50">
        <Card className="w-full max-w-md p-8 border-slate-200">
          <div className="flex items-center gap-3">
            <img src="/logo.jpg" alt="The Smith International" className="h-14 w-auto object-contain" />
            <div className="text-indigo-700">
              <div className="text-xs uppercase tracking-[0.2em] font-semibold">Sign in</div>
            </div>
          </div>
          <h2 className="font-display text-3xl font-bold mt-4">Welcome back</h2>
          <p className="text-sm text-slate-500 mt-1">
            Use your owner account to continue.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white"
              disabled={loading}
              data-testid="login-submit"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
            <p className="text-xs text-slate-400 pt-2">
              Default demo credentials are pre-filled for you.
            </p>
          </form>
        </Card>
      </div>
    </div>
  );
}
